import { createFileRoute } from '@tanstack/react-router'
import { OrderDetailPage } from '@/pages/order-detail'

export const Route = createFileRoute('/_authenticated/orders/$orderId')({
  staticData: { title: 'Sales Order' },
  component: OrderDetailRoute,
  validateSearch: (search: Record<string, unknown>): { action?: string } => ({
    action: typeof search.action === 'string' ? search.action : undefined,
  }),
})

function OrderDetailRoute() {
  const { orderId } = Route.useParams()
  const { action } = Route.useSearch()
  return <OrderDetailPage orderId={orderId} actionUuid={action} />
}
